import api from '../apiSalesBo';

import { ParamsDataPolicyPdfRequest, ParamsBodyPolicyPdfRequest } from 'utils/typeServices';

export const PostPolicyPdfRequest = async ({ token, body }: { token: string, body: ParamsBodyPolicyPdfRequest }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<ParamsDataPolicyPdfRequest>('AfterSales/PolicyPdfRequest', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data };
    } catch (error: any) {
        return { data: null };
    }
}
